// \src\utils\whiteBoardUtil.js
export const getWhiteBoardDataByCurrentPresentationAndCurrentTime = (whiteboardEventData, currentWhiteboardId, currentTime) => {

    let searchWhiteboardInfoList = [];

    // 遍历whiteboardEventData，查询 whiteboardEventItem.data.whiteboardId = currentWhiteboardId，并且whiteboardEventItem.milliseconds <= currentTime的数据
    whiteboardEventData.forEach(whiteboardEventItem => {

        if (whiteboardEventItem.data.whiteboardId === currentWhiteboardId && whiteboardEventItem.milliseconds <= currentTime) {
            searchWhiteboardInfoList.push(whiteboardEventItem)
        }
    });
    
    return searchWhiteboardInfoList;
}

export const filterWhiteboardInfo = (whiteboardInfoList) => { 

    // 模拟白板操作，先将有效的白板信息过滤出来
    let tempWhiteboardInfoList = []
    let undoWhiteboardInfoList = []
    whiteboardInfoList.forEach(whiteboardInfo => {

        // 321: push一个，323：从tempWhiteboardInfoList删除最新一个，并添加到undoWhiteboardInfoList中; 324: 从undoWhiteboardInfoList删除最新一个，并添加tempWhiteboardInfoList到中
        // 325: 清空tempWhiteboardInfoList, undoWhiteboardInfoList; 326: 从tempWhiteboardInfoList中找到记录，并删除该记录
        // 327: 从tempWhiteboardInfoList中找到记录，并更新信息；
        if(whiteboardInfo.type === 321) {
          tempWhiteboardInfoList.push(whiteboardInfo);
        } else if(whiteboardInfo.type === 323) {
          if(tempWhiteboardInfoList.length > 0) {
            whiteboardInfoList.push(tempWhiteboardInfoList.pop());
          }
        } else if(whiteboardInfo.type === 324) { 
          if(undoWhiteboardInfoList.length > 0) {
            tempWhiteboardInfoList.push(undoWhiteboardInfoList.pop());
          }
        } else if(whiteboardInfo.type === 325) { 
          tempWhiteboardInfoList = []
          undoWhiteboardInfoList = []
        } else if(whiteboardInfo.type === 326) { 
          // 遍历 whiteboardInfo.data.shapeId
          if(whiteboardInfo.data.shapesId) { 
            for (let i = 0; i < whiteboardInfo.data.shapesId.length; i++) {
              const shapeId = whiteboardInfo.data.shapesId[i];
              const index = tempWhiteboardInfoList.findIndex(item => item.data.shapeId === shapeId);
              if(index >= 0) {
                tempWhiteboardInfoList.splice(index, 1);
              }
            }
          }
        } else if(whiteboardInfo.type === 327) { 
          // 遍历 whiteboardInfo.data.shapes
          if(whiteboardInfo.data.shapes) { 
            for (let i = 0; i < whiteboardInfo.data.shapes.length; i++) {
              const shape = whiteboardInfo.data.shapes[i];
              const index = tempWhiteboardInfoList.findIndex(item => item.data.shapeId === shape.shapeId);
              if(index >= 0) {
                tempWhiteboardInfoList[index].data = whiteboardInfo.data?.shapes[0];
              }
            }
          }
        }
    });

    return tempWhiteboardInfoList;
}

export const drawWhiteboardByWhiteboardInfo = async (canvasRef, whiteboardInfoList, baseWidth, baseHeight, scaleRate) => { 

  if (!canvasRef.current) {
      return;
  }

  const canvas = canvasRef.current;
  canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height);

  whiteboardInfoList.forEach(whiteboardInfo => { 
      switch (whiteboardInfo.data.type) {
          case 'text':
              drawText(canvasRef, whiteboardInfo.data, baseWidth, baseHeight, scaleRate);
              break;
          case 'line':
              drawLine(canvasRef, whiteboardInfo.data, baseWidth, baseHeight, scaleRate);
              break;
          case 'pencil':
              drawPencil(canvasRef, whiteboardInfo.data, baseWidth, baseHeight, scaleRate);
              break;
          case 'rectangle':
              drawRectangle(canvasRef, whiteboardInfo.data, baseWidth, baseHeight, scaleRate);
              break;
          default:
              console.log('unknown whiteboard type');                
      }
  });
}

/**
 * 魔棒绘制
*/
export const drawWhiteboardCursorByCursorInfo = (canvasRef, currentCursorInfo, baseWidth, baseHeight, scaleRate) => { 

  if (!canvasRef.current) {
      return;
  }

  // 1. 获取设备像素比
  const dpr = window.devicePixelRatio || 1;

  const canvas = canvasRef.current;
  canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height);

  if (!currentCursorInfo) return;

  // 以 currentCursorInfo.cursorX、currentCursorInfo.cursorY、currentCursorInfo.diameter 绘制一个圆形魔棒，颜色红色
  const cursorX = formatX(baseWidth, currentCursorInfo.cursorX + currentCursorInfo.diameter * 2) * scaleRate;
  const cursorY = formatY(baseHeight, currentCursorInfo.cursorY + currentCursorInfo.diameter * 2) * scaleRate;
  const diameter = currentCursorInfo.diameter * dpr;

  const ctx = canvas.getContext('2d');

  // 绘制红色圆形
  // 绘制外圆（淡红色）
  ctx.beginPath();
  ctx.arc(cursorX, cursorY, diameter * 2, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(255, 100, 100, 0.7)';
  ctx.fill();

  // 绘制内圆（红色）
  ctx.beginPath();
  ctx.arc(cursorX, cursorY, diameter, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(255, 0, 0, 0.9)';
  ctx.fill();
}

/**
 * textInfo: {
        "shapeId": "54db0b6c-fbf2-4ff9-9e21-8a03b3553ca1",
        "whiteboardId": "w_c02d5ad788c34c3292b59d4bc0a52e2c",
        "x": 209,
        "y": 434,
        "fontSize": 18,
        "text": "Guten Morgen.\n",
        "type": "text",
        "operatorId": "483762",
        "textColor": "#EC2629",
        "roomId": "2-162191",
        "timestamp": 1751090497247
    }
*/
export const drawText = (canvasRef, textInfo, baseWidth, baseHeight, scaleRate) => { 

    if (!canvasRef.current || !textInfo) return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    const { x, y, fontSize, text, textColor, fontFamily } = textInfo;

    // 先重置变换矩阵
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    
    // 应用缩放
    const scaledX = formatX(baseWidth, x) * scaleRate;
    const scaledY = formatY(baseHeight, y) * scaleRate;

    // 转为 800 * 600标准尺寸对应的字体大小
    let scaledFontSize = fontSize * scaleRate
    if(baseWidth / baseHeight > 4 / 3) {
      scaledFontSize = Math.round(Math.min(formatX(baseWidth, fontSize), formatY(baseHeight, fontSize))) * scaleRate
    }

    // console.log("baseWidth: ", baseWidth, ", baseHeight: ", baseHeight, ", fontSize: ", fontSize, ", formatFontSize: ", Math.round(Math.min(formatX(baseWidth, fontSize), formatY(baseHeight, fontSize))), ", scaledFontSize: ", scaledFontSize)

    // 清除画布（如果需要）
    // ctx.clearRect(0, 0, canvas.width, canvas.height);

    // 设置文本样式
    ctx.font = `${scaledFontSize}px "${ fontFamily && fontFamily === 'NSSC' ? 'Noto Sans SC' : 'Arial' }"`; // 确保字体大小和类型保持一致
    // ctx.font = `${scaledFontSize}px "Noto Sans SC"`; // 确保字体大小和类型保持一致
    ctx.fillStyle = textColor || '#000000'; // 默认黑色
    ctx.textBaseline = 'hanging'; // 文本从顶部开始绘制，符合 y 坐标逻辑

    // 如果仍然显得过粗，可以尝试改变字体系列或抗锯齿策略
    // ctx.font = `normal ${scaledFontSize}px Arial`; // 强制正常宽度字体
    // 或者尝试不同的字体系列如 'Helvetica', 'sans-serif'
    // 计算行高
    var lineHeight = scaledFontSize * 1.45; // 根据实际需要调整比例

    // 将 \t转为8个字符串长度
    const formatText = text.replace(/\t/g, '        ');

    // 支持多行文本（按 \n 分割）
    const lines = formatText.split('\n');

    lines.forEach((line, index) => {
        ctx.fillText(line, scaledX, scaledY + index * lineHeight + fontSize / 2);
    });
}

/**
 * lineInfo: {
        "endY": 349,
        "endX": 292,
        "shapeId": "19e477a9-cb13-4151-b53e-1a479121504c",
        "color": "#EC2629",
        "thickness": 3,
        "whiteboardId": "w_5a859bacf751453dba093ff5e939fc4e",
        "startY": 351,
        "startX": 226,
        "type": "line",
        "operatorId": "483762",
        "roomId": "2-162191",
        "timestamp": 1751090617827
    }
*/
export const drawLine = async (canvasRef, lineInfo, baseWidth, baseHeight, scaleRate) => { 
    if (!canvasRef.current || !lineInfo) return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    // 解构赋值获取需要的属性
    const { startX, startY, endX, endY, color, thickness } = lineInfo;

  // 先重置变换矩阵
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    
    // 应用缩放
    const scaledStartX = formatX(baseWidth, startX) * scaleRate;
    const scaledStartY = formatY(baseHeight, startY) * scaleRate;
    const scaledEndX = formatX(baseWidth, endX) * scaleRate;
    const scaledEndY = formatY(baseHeight, endY) * scaleRate;
    const scaledThickness = thickness * scaleRate;

    // 设置线条样式
    ctx.strokeStyle = color || '#000000'; // 默认黑色
    ctx.lineWidth = scaledThickness;
    ctx.lineCap = 'round'; // 线条端点为圆形

    // 开始绘制路径
    ctx.beginPath();
    ctx.moveTo(scaledStartX, scaledStartY);
    ctx.lineTo(scaledEndX, scaledEndY);

    // 绘制路径
    ctx.stroke();

    // 清理
    ctx.closePath();
}

/**
 * pencilInfo: {
        "shapeId": "42c48f00-9ede-4a7d-9981-5df96d8ee18e",
        "color": "#EC2629",
        "thickness": 3,
        "whiteboardId": "w_1fd4f5551121421295cf740998e65c14",
        "type": "pencil",
        "operatorId": "483762",
        "roomId": "2-162191",
        "points": [
          {
            "x": 351,
            "y": 217
          },
          {
            "x": 349,
            "y": 217
          },
          {
            "x": 349,
            "y": 217
          },
          {
            "x": 347,
            "y": 217
          },
          {
            "x": 346,
            "y": 217
          },
          {
            "x": 345,
            "y": 217
          },
          {
            "x": 345,
            "y": 217
          },
          {
            "x": 344,
            "y": 217
          },
          {
            "x": 343,
            "y": 217
          },
          {
            "x": 342,
            "y": 217
          },
          {
            "x": 342,
            "y": 217
          },
          {
            "x": 341,
            "y": 217
          },
          {
            "x": 339,
            "y": 217
          },
          {
            "x": 339,
            "y": 217
          },
          {
            "x": 337,
            "y": 217
          },
          {
            "x": 336,
            "y": 217
          },
          {
            "x": 335,
            "y": 217
          },
          {
            "x": 334,
            "y": 217
          },
          {
            "x": 333,
            "y": 217
          },
          {
            "x": 332,
            "y": 217
          },
          {
            "x": 331,
            "y": 217
          }
        ],
        "timestamp": 1751091709077
    }
*/
export const drawPencil = async (canvasRef, pencilInfo, baseWidth, baseHeight, scaleRate) => { 
    if (!canvasRef.current || !pencilInfo) return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
      
    // 先重置变换矩阵
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    
    const {
      points,
      color,
      thickness,
    } = pencilInfo;
  
    // 设置样式
    ctx.strokeStyle = color || '#000000'; // 默认黑色
    ctx.lineWidth = thickness * scaleRate; // 根据缩放比例调整线条宽度
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
  
    // 开始路径
    ctx.beginPath();
  
    let isFirstPoint = true;
    if(points && points.length > 0) {
        points.forEach((point, index) => {
            const scaledX = formatX(baseWidth, point.x) * scaleRate;
            const scaledY = formatY(baseHeight, point.y) * scaleRate;
        
            if (isFirstPoint) {
              ctx.moveTo(scaledX, scaledY);
              isFirstPoint = false;
            } else {
              ctx.lineTo(scaledX , scaledY);
            }
          });
        
          // 绘制路径
          ctx.stroke();
    }
    
    // 关闭路径
    ctx.closePath();
}

/**
 * rectangleInfo: {
        "shapeId": "8cb35469-0e60-49bd-8e36-da6ed6a30a33",
        "color": "#EC2629",
        "thickness": 3,
        "whiteboardId": "w_5a859bacf751453dba093ff5e939fc4e",
        "width": 3,
        "startY": 425,
        "startX": 172,
        "type": "rectangle",
        "operatorId": "483762",
        "roomId": "2-162191",
        "height": 0,
        "timestamp": 1751090675213
    }
*/
export const drawRectangle = async (canvasRef, rectangleInfo, baseWidth, baseHeight, scaleRate) => { 
    if (!canvasRef.current || !rectangleInfo) return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
  
    // 先重置变换矩阵
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    
    const {
      startX,
      startY,
      width,
      height,
      color,
      thickness
    } = rectangleInfo;
  
    // 缩放坐标和尺寸
    const scaledStartX = formatX(baseWidth, startX) * scaleRate;
    const scaledStartY = formatY(baseHeight, startY) * scaleRate;
    const scaledWidth = formatX(baseWidth, width) * scaleRate;
    const scaledHeight = formatY(baseHeight, height) * scaleRate;
    const scaledThickness = thickness * scaleRate;
  
    // 设置样式
    ctx.strokeStyle = color || '#000000'; // 默认黑色
    ctx.lineWidth = scaledThickness;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
  
    // 开始路径
    ctx.beginPath();
  
    if (scaledWidth === 0 && scaledHeight === 0) {
      // 退化为点：绘制一个圆点
      ctx.arc(scaledStartX, scaledStartY, scaledThickness / 2, 0, Math.PI * 2);
      ctx.stroke();
    } else if (scaledWidth === 0) {
      // 退化为垂直线
      ctx.moveTo(scaledStartX, scaledStartY);
      ctx.lineTo(scaledStartX, scaledStartY + scaledHeight);
      ctx.stroke();
    } else if (scaledHeight === 0) {
      // 退化为水平线
      ctx.moveTo(scaledStartX, scaledStartY);
      ctx.lineTo(scaledStartX + scaledWidth, scaledStartY);
      ctx.stroke();
    } else {
      // 正常矩形：注意 canvas rect 的 x/y 是左上角，width/height 是正数
      // 确保无论原始数据方向如何，都正确绘制
      const x = scaledStartX;
      const y = scaledStartY;
      const w = scaledWidth;
      const h = scaledHeight;
  
      ctx.rect(x, y, w, h);
      ctx.stroke();
    }
  
    // 关闭路径
    ctx.closePath();
}

const formatX = (baseWidth, x) => { 
  return x * (baseWidth / 800);
}

const formatY = (baseHeight, y) => { 
  return y * (baseHeight / 600);
}